<template>
  <div class="TripTypeHeader">
    <Icon
      class="TripTypeHeader-prependIcon"
      :icon="headerIcon"
      size="lg"
      flipRtl
    />

    <span class="TripTypeHeader-label">
      <span class="TripTypeHeader-prefix">{{ headerLabel }}<template v-if="$slots.default"> |</template></span> <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import Icon from '../../../atoms/Icon/Icon.vue';
import type { IconName } from '../../../atoms/Icon/Icon.model';

interface TripTypeHeaderProps {
  icon?: IconName;
  returnTrip?: boolean;
}

const props = defineProps<TripTypeHeaderProps>();

const { t } = useI18n();

const headerIcon = computed(() => {
  return props.icon ?? (props.returnTrip ? 'arrow-left' : 'arrow-right');
});

const headerLabel = computed(() => {
  return props.returnTrip ? t('ui.booking.availability.results.inbound.title') : t('ui.booking.availability.results.outbound.title');
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/layout';
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .TripTypeHeader {
    display: flex;
    align-items: center;
    gap: vars.$dimensions-d-2;
    color: vars.$organisms-tripdisplay-segmentdetails-direct-default-title-color;
    @include text.heading(h5);

    @container(max-width: #{vars.$screen-sm-max-width}) {
      @include text.heading(h6);
      --icon-size: 20px;
    }

    .prependIcon {
      color: vars.$organisms-tripdisplay-segmentdetails-direct-default-icon-primary-color;
    }

    &-label {
      min-width: 0;
    }

    &-prefix {
      white-space: nowrap;
    }
  }
}
</style>
